import React from 'react';
import store from '../../../platform/viewer/src/store';
import Render3D from './Render3D.js';

export default function withCommandsManager(Component, commandsManager = {}) {
  return class WithCommandsManager extends React.Component {
    render() {
      const { viewportIndex, viewportData } = this.props;
      const layout = store.getState().viewports.layout;
      const viewportLayout = layout.viewports[viewportIndex];
      const mode = viewportLayout && viewportLayout.vtk && viewportLayout.vtk.mode;

      if (mode === '3d') {
        return <Render3D viewportData={viewportData} />;
      }

      return (
        <Component
          {...this.props}
          onScroll={viewportIndex =>
            commandsManager.runCommand('getVtkApiForViewportIndex', {
              index: viewportIndex,
            })
          }
        />
      );
    }
  };
}
